// ante-react-kit/src/components/AntQuickPopup/QuickPopupContext.js
import React, { createContext, useContext } from 'react';

const QuickPopupContext = createContext(null);

export function QuickPopupProvider({ value, children }) {
    return <QuickPopupContext.Provider value={value}>{children}</QuickPopupContext.Provider>;
}

export function useQuickPopupContext() {
    const ctx = useContext(QuickPopupContext);
    if (!ctx) {
        throw new Error('useQuickPopupContext must be used inside <AntQuickPopup>');
    }
    return ctx;
}

export default QuickPopupContext;
